import React, { useState } from "react";
import moment from "moment-timezone";
import FilledButton from "components/InterstellrComponents/FilledButton";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const CommonReportCard = ({ report, onResolve }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="h-full w-full rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="border-b border-gray-200 rounded-t-xl bg-red-700 px-4 pb-4 pt-4">
        <h6 className="text-base font-semibold text-white">
          {report?.type ?? ""}
        </h6>
      </div>

      <div className="flex flex-col items-start justify-start px-4 pb-3 overflow-hidden">
        <h2
          style={{ height: expanded ? "120px" : "72px" }}
          className="text-base font-normal w-full text-black pt-3 flex-wrap overflow-hidden"
        >
          {report?.description ?? ""}
        </h2>

        <div
          onClick={() => setExpanded(!expanded)}
          className="w-full flex flex-row justify-center items-center cursor-pointer pt-2"
        >
          <p className="text-sm font-semibold text-[#5153F5] text-center">
            Read {expanded ? "Less" : "More"}
          </p>
          {!expanded ? (
            <FaChevronDown className="ml-2 text-sm text-[#5153F5]" />
          ) : (
            <FaChevronUp className="ml-2 text-sm text-[#5153F5]" />
          )}
        </div>
        {/* Customer Details */}
        <div className="flex flex-row mt-1">
          <div>
            <p className="text-sm font-medium mt-2 underline mb-1">
              Reported by
            </p>
            <p className="font-medium text-black text-sm">
              {report?.submittedBy?.firstname ?? ""}{" "}
              {report?.submittedBy?.lastname ?? ""}
            </p>

            <p className="font-medium text-black text-sm">
              {report?.submittedBy?.mobile ?? ""}
            </p>

            <p className="font-medium text-black text-sm">
              {report?.submittedBy?.email ?? ""}
            </p>

            <p className="text-sm text-red-700 font-semibold mt-2 underline mb-0.5">
              Submitted on
            </p>
            <p className="font-medium text-red-700 text-sm">
              {moment(report?.createdAt).format("Do MMMM yyyy @ h:mm a") ?? ""}
            </p>

            {report?.resolvedAt ? (
              <>
                <p className="text-sm text-[#5153F5] font-semibold mt-2 underline mb-0.5">
                  Resolved at
                </p>
                <p className="font-medium text-[#5153F5] text-sm">
                  {moment(report?.resolvedAt).format("Do MMMM yyyy @ h:mm a") ??
                    ""}
                </p>
              </>
            ) : null}
          </div>
        </div>

        {report?.status == "submitted" ? (
          <FilledButton
            text={"Mark as Resolved"}
            marginTop={8}
            onPress={() => onResolve(report)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CommonReportCard;
